import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wa-menu',
  templateUrl: './wa-menu.component.html',
  styleUrls: ['./wa-menu.component.scss']
})
export class WaMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
